import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import { UtilsContainer } from 'containers'

type LoaderProps = {
  variant?: 'inline' | 'fullScreen' | 'inlineFull'
  customChild?: React.ReactNode
}

export const Loader: React.FC<LoaderProps> = ({ variant = 'fullScreen', customChild }) => {
  const { singletonLoader, setSingletonLoader } = UtilsContainer.useContainer()
  const [uniqueID] = React.useState(Math.random().toString(36).slice(2)) //NOSONAR

  React.useEffect(() => {
    if (variant === 'fullScreen') {
      const loaderElements = document.getElementsByName('full-screen-loader')
      setSingletonLoader(loaderElements?.[0]?.id ?? '')

      return () => {
        setSingletonLoader(loaderElements?.[0]?.id ?? '')
      }
    }
  }, [variant, uniqueID, setSingletonLoader])

  return (
    <div data-testid="circular-loader">
      {variant === 'inline' && <CircularProgress />}
      {variant === 'inlineFull' && (
        <div
          className="flex absolute z-max w-full h-full left-0 top-0 items-center justify-center"
          style={{
            backgroundColor: `rgba(209, 213, 219, 0.4)`,
          }}
        >
          <CircularProgress />
        </div>
      )}
      {variant === 'fullScreen' && (
        <>
          <meta id={uniqueID} name="full-screen-loader" />
          {singletonLoader === uniqueID && (
            <div>
              {customChild ? (
                <div
                  className="fixed inset-0 z-max h-screen w-screen flex flex-col items-center justify-center"
                  style={{
                    backgroundColor: `rgba(156, 163, 175, 0.4)`,
                  }}
                >
                  {customChild}
                </div>
              ) : (
                <div
                  className="fixed inset-0 z-max h-screen w-screen flex items-center justify-center"
                  style={{
                    backgroundColor: `rgba(156, 163, 175, 0.4)`,
                  }}
                >
                  <CircularProgress color="primary" />
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  )
}
